/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';

const { PERSIST_KEY } = configENV;

class DesktopRemoveCreditCard extends React.PureComponent {
    render() {
        const {
            walletId,
            isDefaultCard,
            handleCloseModal,
            handleRemoveCreditCard,
        } = this.props;
        return (
            isDefaultCard ? (
                <>
                    <div className="bold align-center">This card is associated with a Subscription or Passport order.</div>
                    <div className="bold margin-top align-center">A new default card must be selected<br />before this card can be deleted.</div>
                    <div className="buttonForm padding-right-2x">
                        <Button
                            onClick={() => handleCloseModal()}
                            variant="contained"
                            color="primary"
                            className="float-none"
                        >
                            OK
                        </Button>
                    </div>
                </>
            )
                : (
                    <>
                        <p>
                            Are you sure you want to
                            delete this card?
                        </p>
                        <div className="align-center padding-top-2x">
                            <Button
                                onClick={() => handleCloseModal()}
                                className="float-none margin-right-2x secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => handleRemoveCreditCard(walletId)}
                                className="float-none no-margin red"
                            >
                                Delete
                            </Button>
                        </div>
                    </>
                )
        );
    }
}
DesktopRemoveCreditCard.defaultProps = {
    walletId: '',
    isDefaultCard: false,
};

DesktopRemoveCreditCard.propTypes = {
    walletId: PropTypes.string,
    isDefaultCard: PropTypes.bool,
    handleCloseModal: PropTypes.func.isRequired,
    handleRemoveCreditCard: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        walletId: newState.walletId,
        isDefaultCard: newState.isDefaultCard,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleCloseModal: () => dispatch(EventDispatcher.handleCloseModal()),
    handleRemoveCreditCard: (walletId) => dispatch(EventDispatcher.handleRemoveCreditCard(walletId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DesktopRemoveCreditCard);
